<template>
    <div class="mcg-letterhead">
        <div class="mcg-title">Mc Geoughs Funeral Ltd</div>
        <div class="mcg-details">
            <div>
                <div>Kia Ora</div>
                <div>Jocelyn St</div>
                <div>Dundalk A91 XW66</div>
            </div>
            <div class="mcg-right">
                <div>Phone 042 93 34283</div>
                <div>Email info@mcgeoughs.ie</div>
                <div>Mobile 086 8212126</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'McGeoughsLetterhead',
}
</script>

<style scoped lang="scss">
.mcg-letterhead {
    color: black;
    font-family: 'Times New Roman', Times, serif;
}

.mcg-title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 36px;
    line-height: 1.1;
    text-align: center;
}

.mcg-details {
    display: flex;
    justify-content: space-between;
    font-style: italic;
    font-size: 12px;
    line-height: 1.2;
}

.mcg-right {
    text-align: right;
}
</style>
